<script setup lang="ts">
import { ICON } from "@/lib/icons"

defineProps<{
  previewUrl: string | null
  formatName: string
  quantity: number
  printStatus: "idle" | "printing" | "printed" | "error"
  printMessage: string
  canPrint: boolean
}>()

const emit = defineEmits<{ print: [] }>()
</script>

<template>
  <div class="flex flex-col gap-4">
    <div v-if="previewUrl" class="border-default overflow-hidden rounded-lg border bg-white p-4">
      <img
        :src="previewUrl"
        :alt="`${formatName} label preview`"
        class="mx-auto max-h-56 max-w-full"
      />
    </div>

    <p v-if="quantity > 1" class="text-muted text-center text-sm">Printing {{ quantity }} copies</p>

    <UButton
      :label="quantity > 1 ? `Print (${quantity})` : 'Print'"
      :icon="ICON.print"
      color="primary"
      variant="solid"
      block
      :disabled="!canPrint"
      :loading="printStatus === 'printing'"
      @click="emit('print')"
    />

    <p
      v-if="printMessage"
      class="text-center text-sm"
      :class="printStatus === 'error' ? 'text-error' : 'text-muted'"
    >
      {{ printMessage }}
    </p>
  </div>
</template>
